import React, { FC, ReactNode } from 'react'
import '../assets/scss/loading-dots.scss'

export interface LoadingIndicatorProps {
  /** Whether to show the loading animation */
  loading: boolean
  /** Content to display when not loading */
  children: ReactNode
  /** Optional wrapper module with custom class and inline height style */
  containerModule?: {
    className: string
    css: { height: string | number }
  }
}

const LoadingIndicator: FC<LoadingIndicatorProps> = ({ loading, children, containerModule }) => {
  if (loading) {
    if (containerModule) {
      return (
        <div className={containerModule.className} style={containerModule.css}>
          <div className="stage">
            <div className="dot-pulse"></div>
          </div>
        </div>
      )
    }
    return (
      <div className="stage">
        <div className="dot-pulse"></div>
      </div>
    )
  }

  return <>{children}</>
}

export default LoadingIndicator
